// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_i0-0";
export var fileCarousel = "_i0-2";
export var removeFileButton = "_i0-1";